import { Injectable, AfterViewInit, AfterViewChecked } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class LoaderService {
    public status: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    currentMessage = this.status.asObservable();
    display(value: boolean) {
        this.status.next(value);
    }
}

export class LoadingComponent implements AfterViewInit {

    constructor(private loaderService: LoaderService, private isDefault: boolean) {

    }

    ngAfterViewInit() {
        if (this.isDefault) {
             this.loaderService.display(true);
        }
    }
}
